import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { watchedHoursMetricsApi } from "../../constants/apiConstants";
import request from "../../utils/request";

export const watchedHoursMetrics = createAsyncThunk(
  "watchedHoursMetricsReducer/watchedHoursMetrics",
  async (moviesListPayload) => {
    try {
      const res = await request({
        url: watchedHoursMetricsApi.watchedHoursMetrics,
        method: "POST",
        data: moviesListPayload?moviesListPayload:"",
      });
      return res;
    } catch (error) {
      console.error("watched hours metrics fetch is failed:", error);
      throw error;
    }
  }
);

const watchedHoursMetricsSlice = createSlice({
  name: "watchedHoursMetrics",

  initialState: {
    getWatchedHoursMetricsReq: null,
    iswatchedHoursMetricsLoading: false,
  },
  reducers: {
    watchedHourMetricsRes: (state, action) => {
      state.getWatchedHoursMetricsReq = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(watchedHoursMetrics.pending, (state) => {
        state.iswatchedHoursMetricsLoading = true;
      })
      .addCase(watchedHoursMetrics.fulfilled, (state, action) => {
        state.iswatchedHoursMetricsLoading = false;
        state.getWatchedHoursMetricsReq = action.payload;
      })
      .addCase(watchedHoursMetrics.rejected, (state, action) => {
        state.iswatchedHoursMetricsLoading = false;
      });
  },
});
export const { watchedHourMetricsRes } = watchedHoursMetricsSlice.actions;
export default watchedHoursMetricsSlice.reducer;
